export default {
  'Respiratory syncytial virus (RSV)': 'Respiratory Syncytial Virus (RSV)',
  'Human metapneumovirus': 'Human metapneumovirus (hMPV)',
  Influenza: 'Influenza',
  'COVID-19': 'COVID-19',
  Parainfluenza: 'Parainfluenza Virus (PIV)',
}
